import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">常见问题</h2>
            <p className="text-sm text-foreground-500">关于黑料入口，你想知道的都在这里</p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item) => (
              <div key={item.id} className="bg-background-50 rounded-xl overflow-hidden">
                <button
                  onClick={() => setOpenId(openId === item.id ? null : item.id)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{item.question}</h3>
                  <i
                    className={`text-foreground-400 text-lg flex-shrink-0 transition-transform duration-300 ${
                      openId === item.id ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                {openId === item.id && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}